<template>
  <expert-layout>
    <v-layout wrap>
      <v-flex xs12 class="mx-3">
        <v-toolbar flat dense color="toolbarColor">My reviews ({{reviewAmount}})</v-toolbar>
      </v-flex>

      <v-flex xs12 class="list-section mt-2 pa-3 mx-3">
        <v-layout wrap v-if="reviews.length>=1">
          <div class="red--text text--darken-1 star-margin mb-3">Average Rating: ({{formatRating(reviewUser.rating)}}/5)</div>
          <v-flex xs12 v-for="review in reviews" v-bind:key="review._id" class="mb-4">
            <span v-if="review.sonkoId == undefined" class="green--text text--darken-1 mt-2">{{review.username}}</span>
            <span class="green--text text--darken-1" v-else>{{review.sonkoId.firstName}} {{review.sonkoId.lastName}}</span>
            <br>
            {{review.review}}
            <br>
            <v-rating
              v-bind:value="Math.round(review.rating)"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$vuetify.icons.ratingFull"
              half-increments
              hover
              readonly
            ></v-rating>
            <a href="javascript:void(0)" @click="showReportModal(review._id)" >
              Report the review for moderation…
            </a>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-pagination class="ml-2 mt-2" v-if="reviews.length>=1"
        v-model="currentPage"
        :length="Math.ceil(reviewAmount/perPage)"
        @input="onPageChange"
    ></v-pagination>
    <!-- report review modal -->
      <v-dialog v-model="reportModal" max-width="500px">
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Report Review</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click.native="reportModal=false">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <v-textarea v-model="report_review" label="Description"></v-textarea>
              </v-flex>
              <v-flex xs12>
              <v-btn color="btnColor" small dark @click="reportReview">
                <v-icon>save</v-icon>save
              </v-btn>
            </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- report review modal -->
      <app-snackbar ref="mySnackbar"></app-snackbar>
  </expert-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ReviewsIndex",
  computed: {
    ...mapGetters(["user"])
  },
  data() {
    return {
      reviews: [],
      currentPage: typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1,
      perPage: 8,
      reviewUser: null,
      reviewAmount: 0,
      reportModal: false,
      report_review: null,
      reviewId: 0
    };
  },
  methods: {
    showReportModal(id) {
      this.reviewId = id;
      this.reportModal = true;
    },
    formatRating(rating) {
        return parseFloat(rating.toFixed(1));
    },
    getReviews() {
      let cPage = typeof this.$route.query.page != "undefined"
        ? this.$route.query.page
        : 1;
      const id = this.user._id;
      this.$store.dispatch("get", "/review/expert/" + id+"/"+cPage).then(res => {
        this.reviews = res.reviews;
        this.reviewAmount = res.amount;
        this.currentPage = cPage;
        this.reviewUser = res.user;
      });
    },
    onPageChange(page) {
      this.$router.push({query: {page: page}});
      this.getReviews();
    },
    reportReview() {
      const data = {
        report_review: this.report_review,
        is_report: 1
      };

      const self = this;
      const res = this.$store
        .dispatch("put", { url: "/review/expert/"+this.reviewId, data })
        .then(res => {
          self.$refs.mySnackbar.show("Report Review Successful", "blue");
          self.reportModal = false;
        });
    }
  },
  created() {
    this.getReviews();
  }
};
</script>
